import 'twin.macro';
import React from 'react';
import _orderBy from 'lodash-es/orderBy';
import useSchoolyearsWithSchoolsAndClassrooms from '@teetsh/app/src/queries/schoolyears/useSchoolyearsWithSchoolsAndClassrooms';
import { Schoolyear } from '@teetsh/app/src/types/schoolyear';
import { School } from '@teetsh/app/src/types/school';
import SpinnerComponent from '@teetsh/app/src/components/Spinner/ScreenSpinner';
import { ItemCard } from '@teetsh/app/src/components/EntitiesSelectorModals/components/ItemCard';
import { Classroom } from '@teetsh/app/src/types/classroom';

export interface Option {
  schoolyear: Schoolyear;
  school: School;
  classrooms: Classroom[];
}

interface Props {
  onChange: (v: Option) => void;
  value: string | undefined;
  currentSchoolId?: string;
}

export function SchoolSelector(props: Props) {
  const { data, isInitialLoading } = useSchoolyearsWithSchoolsAndClassrooms();
  const { onChange, value } = props;

  const schoolyears = data || [];
  if (isInitialLoading) {
    return <SpinnerComponent />;
  }
  return (
    <div data-testid="list-schools" tw="grid gap-2">
      {_orderBy(schoolyears, ['year'], ['desc']).map(sy =>
        _orderBy(
          sy.schools.filter(sc => sc.id !== props.currentSchoolId),
          ['name'],
          ['asc'],
        ).map(sc => (
          <ItemCard
            key={sc.id}
            selected={sc.id === value}
            classrooms={sc.classrooms || []}
            onClick={() =>
              onChange({
                school: sc,
                schoolyear: sy,
                classrooms: sc.classrooms,
              })
            }
            school={sc}
            schoolyear={sy}
          />
        )),
      )}
    </div>
  );
}
